import React from 'react'
import { ReadMoreStyled } from './ReadMore.styled'
import { getReadTimeForDisplay } from '../../../../__helpers/get-read-time'

type ReadMoreProps = {
    readTime: number | null
    className?: string
}

export const ReadMore = ({ readTime, className }: ReadMoreProps) => (
    <ReadMoreStyled className={className}>{`Read more${
        readTime !== null ? ` (${getReadTimeForDisplay(readTime)} min)` : ''
    } →`}</ReadMoreStyled>
)

